/*
 * @Author: 温少昌 wenshaochang@huizhihuyu.com
 * @Date: 2024-07-23 10:34:10
 * @LastEditors: 温少昌 wenshaochang@huizhihuyu.com
 * @LastEditTime: 2024-07-23 10:35:04
 * @FilePath: /ny-utils-master/src/utils/env.js
 * @Description: 宿主环境的内核
 */
export default function getEnv() {
    const ua = navigator.userAgent.toLowerCase();
    const isWeiXin = ua.indexOf('micromessenger') !== -1;
    const isInApp = /(^|;\s)app\//.test(ua);
    if (isWeiXin) {
        if ((window).__wxjs_environment === 'miniprogram') {
            return 'wxapp';
        } else {
            return 'wxh5';
        }
    } else {
        if (!isInApp) {
            return 'browser';
        } else {
            return 'app';
        }
    }
}